import { Checkbox, Radio, Tooltip } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import React from "react";
import type { DecisionOptionButton_DocumentItemFragment } from "../../doc-items/fields/DecisionOptionRadioOrCheckbox.generated.js";
import type { ToggleDecisionOptionFn } from "../quote/useDecisionOptionToggle.js";

interface Props {
  item: DecisionOptionButton_DocumentItemFragment;
  toggleDecisionOption: ToggleDecisionOptionFn;
  disabled?: boolean;
}

export const DataGridDecisionOptionCell = ({
  item,
  toggleDecisionOption,
  disabled = false,
}: Props) => {
  const { t } = useTranslate("Decisions");
  const [loading, setLoading] = React.useState(false);
  const selected = item.decisionOptionIsPreselected ?? false;
  const isEliminated = !!item.decisionOptionElimination;

  const onChange = async (event: React.ChangeEvent<any>) => {
    event.preventDefault();
    event.stopPropagation();
    if (!item.parentId) throw new Error("item.parentId is missing");
    setLoading(true);
    try {
      await toggleDecisionOption(item.parentId, item.id);
    } finally {
      setLoading(false);
    }
  };

  const Button =
    item.decisionOptionBehaviour === "SELECT_MANY" ? (
      <Checkbox
        checked={Boolean(selected)}
        onClick={onChange}
        disabled={loading || disabled || isEliminated}
        size="small"
        style={{ flexGrow: 0, flexShrink: 0 }}
      />
    ) : (
      <Radio
        checked={selected}
        onClick={onChange}
        disabled={loading || disabled || isEliminated}
        size="small"
        style={{ flexGrow: 0, flexShrink: 0 }}
      />
    );

  if (isEliminated) {
    return (
      <Tooltip title={t("Decision option is discarded")}>
        <div style={{ display: "flex" }}>{Button}</div>
      </Tooltip>
    );
  }

  return Button;
};
